(function() {
var get_url_separator;

get_url_separator = function(url) {
  if (/\?/.test(url)) {
    return "&";
  } else {
    return "?";
  }
};

$(document).on("click", ".ert_archived_btn", function(e) {
  var _ert_id;
  e.preventDefault();
  _ert_id = $(e.target).data("ert-id");
  $(e.target).hide();
  return $("#ert_archived_" + _ert_id).slideDown("fast");
});

$(document).on("click", ".ert_hide_archived_btn", function(e) {
  var _ert_id;
  e.preventDefault();
  _ert_id = $(e.target).data("ert-id");
  $("#ert_archived_btn_" + _ert_id).show();
  return $("#ert_archived_" + _ert_id).slideUp("fast");
});

}).call(window);
